import { RISING, TRENDS } from "@/mocks/kanliao";

export default function HotList() {
  return (
    <section id="hot" className="relative w-full bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-widest text-primary-600">
              <i className="ri-fire-fill" /> HOT · 实时
            </span>
            <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              今日热榜 · 大家都在搜
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              看料站聚合当下最热的关键词与黑料目录，热度变化一屏看清，点进关键词即可继续定向找瓜。
            </p>
          </div>
          <span className="whitespace-nowrap text-xs text-foreground-500">热度数据每小时更新</span>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="overflow-hidden rounded-xl border border-background-200/80 bg-background-100/60 lg:col-span-2">
            <div className="flex items-center justify-between border-b border-background-200/80 bg-background-100 px-5 py-3">
              <span className="font-heading text-sm font-bold text-foreground-950">热搜关键词 TOP 8</span>
              <span className="whitespace-nowrap text-xs text-foreground-500">按热度排序</span>
            </div>
            <ul className="divide-y divide-background-200/70 px-2">
              {TRENDS.map((t) => (
                <li key={t.rank}>
                  <a
                    href="#featured"
                    className="group flex items-center gap-4 px-3 py-3 transition hover:bg-background-50"
                  >
                    <span
                      className={
                        "flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold " +
                        (t.rank <= 3 ? "bg-primary-500 text-background-50" : "bg-secondary-200 text-secondary-900")
                      }
                    >
                      {t.rank}
                    </span>
                    <span className="flex-1 truncate text-sm font-medium text-foreground-950 group-hover:text-primary-600">
                      {t.kw}
                    </span>
                    <span className="hidden whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900 sm:inline-block">
                      {t.cat}
                    </span>
                    <span className="hidden whitespace-nowrap text-xs text-foreground-500 md:inline-block">
                      {t.heat}
                    </span>
                    <span
                      className={
                        "flex items-center gap-0.5 whitespace-nowrap text-xs font-medium " +
                        (t.up ? "text-accent-600" : "text-foreground-400")
                      }
                    >
                      <i className={t.up ? "ri-arrow-up-line" : "ri-arrow-down-line"} />
                      {t.delta}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-6">
            <div className="overflow-hidden rounded-xl border border-accent-200 bg-accent-50">
              <div className="flex items-center gap-2 border-b border-accent-200 bg-accent-100 px-5 py-3">
                <i className="ri-flashlight-line text-accent-600" />
                <span className="font-heading text-sm font-bold text-accent-900">飙升关键词 · 24h</span>
              </div>
              <ul className="px-4 py-2">
                {RISING.map((r, i) => (
                  <li key={r.kw}>
                    <a href="#featured" className="group flex items-center gap-3 px-1 py-3">
                      <span className="text-xs font-bold text-accent-600">{String(i + 1).padStart(2, "0")}</span>
                      <div className="flex-1">
                        <p className="text-sm font-medium text-foreground-950 group-hover:text-accent-700">{r.kw}</p>
                        <p className="text-xs text-foreground-500">{r.heat}</p>
                      </div>
                      <span className="whitespace-nowrap rounded-full bg-accent-200/80 px-2 py-0.5 text-xs text-accent-900">
                        {r.tag}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="flex flex-1 flex-col justify-center rounded-xl bg-background-950 px-6 py-6">
              <span className="font-heading text-sm font-bold text-foreground-50">检索小贴士</span>
              <p className="mt-2 text-xs leading-relaxed text-foreground-200">
                拿不准搜什么？先看热榜找热点，再叠加人物 / 事件 / 时间标签做二次筛选，命中更准。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}